import React from "react";

export default function Page_3() {
    return(
        <div>
            Page 3
        </div>
    )
}